import React, { useEffect, useState } from 'react'
import SectionContainer from '../../../Homepage/SectionContainer'
import arrow from "../../../assets/kangaroo/arrow-cropped.svg"
import {Container, Col, Row } from 'reactstrap'
import TestimonialService from '../../../services/TestimonialService'
import { useQuery } from '@tanstack/react-query'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import Map from '../../../Homepage/Map'
import SmallPage from '../../../Homepage/SmallPage'
import Explore from '../../../Homepage/Explore'

const Testimonial = () => {
 const [itemsPerSlide, setItemsPerSlide] = useState(3);
 const [visibleCount,setVisibleCount] = useState(6);
  useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth < 576) {
      setItemsPerSlide(1);
    } else if (window.innerWidth < 992) {
      setItemsPerSlide(2);
    } else {
      setItemsPerSlide(3);
    }
  };

  handleResize(); // initial check
  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);

  const fetchData = async () => {
    const response = await TestimonialService.getList();
    return response;
  };

  const { isPending, error, data: testimonialData } = useQuery({
    queryKey: ["testimonial"],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000,
  });

   const handleLoadMore = () => {
    if (visibleCount >= testimonialData?.length) {
      setVisibleCount(6);
    } else {
      // const newCount = visibleCount + 15;
      setVisibleCount(testimonialData?.length || 0);
    }
  };

  

  

  if (isPending) return <div className="text-center p-5">Loading...</div>;
  return (
    <>
    <SectionContainer>
      
      <Container fluid>
         <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "TESTIMONIAL" },
            ]}
          />
           <h1
            className="lh-1 font-level-4 fw-normal text-start p-0 " style={{marginBottom:"clamp(1rem,5vw,4.2rem)"}}
            
          >
            HEAR FROM THOSE <br /> WHO STARTED SMART
          </h1>
         <Row className="g-3 me-3">
            {testimonialData?.slice(0, visibleCount)?.map((item, index) => {
              // Extract YouTube ID for the iframe
              const videoId = item?.videoUrl?.split('v=')[1]?.split('&')[0] || item?.videoUrl?.split('/').pop();
              const embedUrl = `https://www.youtube.com/embed/${videoId}`;

              return (
                <Col xs={12} sm={6} md={4} key={index}>
                  <div
                    className="video-wrapper"
                    style={{
                      width: "100%",
                      height: "550px",
                      overflow: "hidden",
                      borderRadius: "20px",
                      backgroundColor: "#000",
                    }}
                  >
                    <iframe
                      width="100%"
                      height="100%"
                      src={embedUrl}
                      title={`Review ${index}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ borderRadius: "20px" }}
                    ></iframe>
                  </div>
                </Col>
              );
            })}
          </Row>

          <Row >
              <Col className="d-flex flex-column justify-content-center align-items-center mt-5" onClick={handleLoadMore} style={{ cursor: "pointer" }}>
                <h1
                  className="button-font-ins"
                  style={{ cursor: "pointer", color: "#7e1790" }}

                >
                  {testimonialData?.length > 6 && (
                    <span>
                      {visibleCount >= testimonialData?.length
                        ? "LOAD LESS "
                        : "LOAD MORE "}
                    </span>
                  )}

                </h1>

                {testimonialData?.length > 6 && (<div className="d-flex justify-content-center align-items-center">
                  <img src={arrow} className={visibleCount >= testimonialData?.length ? "rotate-180" : "rotate-90"} alt="" />
                </div>)}
              </Col>

            </Row>

      </Container>
        
    </SectionContainer>
    <hr className='line'/>
    <SectionContainer>

    <Explore/>
    </SectionContainer>
    <hr className='line'/>
    <SectionContainer>
    <Map/>
    <hr className='line'/>
    <SmallPage/>
    </SectionContainer>
    </>
  )
}

export default Testimonial